import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

export default function Header() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const { pathname }               = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMenuOpen(false), [pathname]);

  const navLinks = [
    { label: 'Home',       to: '/' },
    { label: 'Services',   to: '/services' },
    { label: 'Blog',       to: '/blog' },
    { label: 'Contact',    to: '/contact' },
  ];

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-inner">
        {/* Logo — .logo-circle is the white ring, .logo-img is the mark (sized independently) */}
        <Link to="/" className="logo" aria-label="Stratos Standard home">
          <span className="logo-circle">
            <img src="/stratos-logo.png" alt="Stratos" className="logo-img" />
          </span>
          <span className="logo-wordmark">STRATOS</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="desktop-nav" aria-label="Main navigation">
          {navLinks.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link ${pathname === to ? 'active' : ''}`}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* CTA buttons */}
        <div className="header-actions">
          <Link to="/become-consultant" className="btn-text-link">
            Become a Consultant
          </Link>
          <Link to="/login" className="btn-text-link">
            Sign in
          </Link>
          <Link to="/book" className="btn btn-primary btn-sm">
            Book a Session
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`mobile-nav ${menuOpen ? 'open' : ''}`} aria-hidden={!menuOpen}>
        <nav>
          {navLinks.map(({ label, to }) => (
            <Link key={to} to={to} className={`mob-link ${pathname === to ? 'active' : ''}`}>
              {label}
            </Link>
          ))}
          <Link to="/become-consultant" className="mob-link">Become a Consultant</Link>
          <Link to="/login" className="mob-link">Sign in</Link>
          <Link to="/book" className="btn btn-primary" style={{ marginTop: '12px', justifyContent: 'center' }}>
            Book a Session
          </Link>
        </nav>
      </div>
    </header>
  );
}
